const addToCart = (items, reload) => {
    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(items)
    })
    .then(res => res.json())
    .then(data => {
        console.log(data)

        if ( reload == true ) {
            location.reload();
        }
    })
    .catch( (error) => {
        console.log(error);
    })
}

const addToCartSection = () => {
    
    let thisCart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    let thisForm = document.querySelector('#product-form-template__main-product');

    const configs = fetchConfig('javascript');
    configs.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete configs.headers['Content-Type'];

    const formData = new FormData(thisForm);
    if (thisCart) {
        formData.append('sections', thisCart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', '/products/botrytis-reisling');
        thisCart.setActiveElement(document.activeElement);
    }
    
     configs.body = formData;

    fetch(`${routes.cart_add_url}`, configs)
    .then((response) => response.json())
    .then((response) => {
        console.log(1);
        console.log(response.status);
        if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});

        console.log(2);
        thisCart.renderContents(response);
        console.log(response)
    })
    .catch((e) => {
        console.error(e);
    })

    // Custom
        // document.dispatchEvent(new CustomEvent('cart:refresh'));
}

const updateCart = (items) => {
    fetch('/cart/change.js', {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(items)
    })
    .then(res => res.json())
    .then(data => {
        location.reload();
    })
    .catch( (error) => {
        console.log(error);
    })
}

// variants = {
//     'items': [
//         {
//             'id': 45631162843286,
//             'quantity': 1
//         },
//         {
//             'id': 45631161696406,
//             'quantity': 2
//         }
//     ]
// }

// addToCart(variants);

document.addEventListener("DOMContentLoaded", () => {
    const MENU_COLLAPSIBLE = document.querySelectorAll('.menu__item-title--collapsible')
    if ( window.innerWidth >= 920) {
        // MENU_COLLAPSIBLE.forEach( item => {
        //     item.addEventListener('mouseover', () => {
        //         item.querySelector('.dropdown-icon').click();
        //     })

        //     item.addEventListener('mouseleave', () => {
        //         item.querySelector('.dropdown-icon').click();
        //     })
        // })
    }

    linkToScroll.forEach( item => {
        document.querySelectorAll(`.section-menu a[href="${item.href}"]`).forEach( href => {
            href.setAttribute('href',item.section);
        })

        document.querySelectorAll(`.section-menu a[href="${item.section}"]`).forEach( section => {

            section.addEventListener('click', function (e) {
                e.preventDefault();

                let href =  item.section; 
                let offsetTop = document.querySelector(href).offsetTop - document.querySelector('.section-menu .accordion__panel').offsetHeight;

                scroll({
                    top: offsetTop,
                    behavior: "smooth"
                });

                // in mobile
                if ( document.querySelector('.section-menu .accordion-toggle.is-open .accordion__summary') ) {
                    document.querySelector('.section-menu .accordion-toggle.is-open .accordion__summary').click();
                }
            });
        })
    })


    // setTimeout(function() {
    //     document.querySelectorAll('.bcontact-491748').forEach( form => {
    //         let enquiry_price = form.querySelector('.bcontact_checkbox input[value="Price & Package"]');
    //         let enquiry_availability = form.querySelector('.bcontact_checkbox input[value="Availability"]');
    //         // let enquiry_other = form.querySelector('.bcontact_checkbox input[value="Other"]');

    //         if ( enquiry_price ) {
    //             enquiry_price.addEventListener('change', () => {
    //                 if ( enquiry_price.checked ) {
    //                     form.querySelector('#bcontact-NUMBER-OF-GUESTS-491748').closest('.bcontact-field').style.display = "block"
    //                 } else {
    //                     form.querySelector('#bcontact-NUMBER-OF-GUESTS-491748').closest('.bcontact-field').style.display = "none"
    //                 }
    //             })
    //         }

    //         if ( enquiry_availability ) {
    //             enquiry_availability.addEventListener('change', () => {
    //                 if ( enquiry_availability.checked ) {
    //                     form.querySelector('.bcontact-datetime-input').closest('.bcontact-field').style.display = "block"
    //                 } else {
    //                     form.querySelector('.bcontact-datetime-input').closest('.bcontact-field').style.display = "none"
    //                 }
    //             })
    //         }

    //         // if ( enquiry_other ) {
    //         //     enquiry_other.addEventListener('change', () => {
    //         //         if ( enquiry_other.checked ) {
    //         //             form.querySelector('#bcontact-message-491748').closest('.bcontact-field').style.display = "block"
    //         //         } else {
    //         //             form.querySelector('#bcontact-message-491748').closest('.bcontact-field').style.display = "none"
    //         //         }
    //         //     }) 
    //         // }
    //     })
    // }, 2000);

    setTimeout( () => {
        var form = document.querySelector('form#bcontact-form-491748');
        if (!form) return false;

        console.log('Form found: ' + form);

        form.addEventListener('submit', function(event) { 
            // Optional: if you know there is AJAX, you might want to wait for the AJAX complete or success message instead window.
            dataLayer = window.dataLayer || []; window.dataLayer.push({ 'event': 'weddingsFormSubmit', 'form_id': form.id || '', 'form_classes': form.className || '', 'page_location': window.location.href }); 
            console.log(dataLayer);
        }); 
    },1000);

    
    if ( document.querySelector('button#popup-winehub') ) {

        const oldElement = document.querySelector('button#popup-winehub');
        const newElement = oldElement.cloneNode(true); // true = deep clone with children
        oldElement.parentNode.replaceChild(newElement, oldElement);

        
        document.querySelector('button#popup-winehub').addEventListener('click', (e) => {
            e.preventDefault();

            if ( document.querySelector('#section--winehub') ) {
                document.querySelector('#section--winehub').querySelector('.popup').classList.add('active');
            }
        });
    }

    if ( document.querySelector('#section--winehub button.close-popup') ) {
        document.querySelector('#section--winehub button.close-popup').addEventListener('click', () => {
            
            if ( document.querySelector('#section--winehub') ) {
                document.querySelector('#section--winehub').querySelector('.popup').classList.remove('active');
            }
        })
    }

    document.querySelectorAll('.qikify-toggler').forEach( btn => {
        btn.addEventListener('click', () => {
            document.querySelector('.bcontact-trigger-button').click();
        })
    })

    document.querySelectorAll('.qty-picker').forEach(picker => {
        const input  = picker.querySelector('.qty-input');
        const minus  = picker.querySelector('.qty-minus');
        const plus   = picker.querySelector('.qty-plus');

        const min = parseInt(picker.dataset.min) || 1;
        const max = parseInt(picker.dataset.max) || 999;

        minus.addEventListener('click', () => {
            let val = parseInt(input.value);
            if (val > min) input.value = val - 1;
        });

        plus.addEventListener('click', () => {
            let val = parseInt(input.value);
            if (val < max) input.value = val + 1;
        });
    });

    // Count the wines in cart then show .wines-in-cart
    if ( wine_minimum_enable == true || checkout_via_condition == true ) {
        let listAllWines = [];
        let countAllWines = [];

        fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
            if ( wine_minimum_enable == true ) {
                console.log('Custom: Wines in cart')
                cart.items.forEach(item => {
                    if ( item.product_type != "Gift Giving" ) {
                        listAllWines.push(item.product_id);
                    }
                })

                if ( listAllWines.length >= wine_minimum) {
                    document.querySelectorAll('.wines-in-cart').forEach( item => {
                        item.classList.add('active');
                    })
                }
            }

            if ( checkout_via_condition == true ) {
                console.log('Custom: Checkout via Condition');

                if ( document.querySelector('#checkout_base_condition') ) {
                    document.querySelector('#checkout_base_condition').style.display = 'none';
                }

                cart.items.forEach(item => {
                    if ( item.product_type != "Gift Giving" ) {
                        countAllWines.push(
                            {
                                'id': item.product_id,
                                'quantity': item.quantity
                            }
                        );
                    }
                })

                let checker = cart.items.find(i => i.id === checkout_product_condition ); 
                
                if ( checker ) {
                    console.log('Custom: Checkout Product Condition Found!')
                    document.querySelector('#CartDrawer-Checkout').disabled = true;
                    document.querySelector('#CartDrawer-Checkout').classList.add('disabled');
                    document.querySelector('.drawer__footer-actions').classList.add('disabled');

                    document.querySelectorAll('.wines-in-cart').forEach( item => {
                        item.classList.remove('active');
                    })

                    let totalQty = countAllWines.reduce((sum, obj) => sum + obj.quantity, 0);

                    if ( document.querySelector('#checkout_base_condition') ) {
                        document.querySelector('#checkout_counter').innerHTML = totalQty
                        document.querySelector('#checkout_base_condition').style.display = 'block';
                    }

                    if ( totalQty >= checkout_limit ) {
                        
                        console.log('Custom: Checkout limit Reach! Enable checkout')
                        document.querySelector('#CartDrawer-Checkout').disabled = false;
                        document.querySelector('#CartDrawer-Checkout').classList.remove('disabled');
                        document.querySelector('.drawer__footer-actions').classList.remove('disabled');

                        
                        if ( document.querySelector('#checkout_base_condition') ) {
                            document.querySelector('#checkout_base_condition').style.display = 'none';
                        }
                    }
                }
            }
        })
    }

    document.querySelectorAll('.text-expand').forEach( element => {
        element.querySelector('button.text-expand-toggle').addEventListener('click', () => {
            element.classList.toggle('active');
        })
    })

    // GWP
    if ( gwp == true && Shopify.currency.active == "AUD" && gwp_product_available == true ) {
        console.log('Custom: GWP');
        fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
            
            let checker = cart.items.find(i => i.id === gwp_product_variant_id);

            if ( cart.total_price > gwp_threshold ) {
                console.log('Custom: Cart total > GWP Threshold');
                if ( !checker ) {
                    console.log('Custom: Adding GWP');

                    variants = {
                        'items': [
                            {
                                'id': gwp_product_variant_id,
                                'quantity': 1
                            }
                        ]
                    }

                    addToCart(variants, true);
                    // addToCartSection();
                } else {
                    console.log('Custom: GWP Already in cart');
                }
            } else {
                console.log('Custom: Cart total < GWP Threshold');

                if ( checker ) {
                    console.log('Custom: GWP Product found! Removing');
                    
                    let updates = {
                        id: gwp_product_variant_id.toString(),
                        quantity: 0
                    }

                    updateCart(updates);
                } else {
                    console.log('Custom: GWP is not in cart');
                }
            }
        })
    }

    document.querySelectorAll('.button--tab').forEach( element => {
        element.addEventListener('click', () => {
            document.querySelectorAll('.button--tab').forEach( buttonTabs => {
                buttonTabs.classList.remove('active');
            })

            document.querySelectorAll('.as-tab').forEach( tabs => {
                tabs.classList.remove('active');
            })

            element.classList.add('active');
            document.querySelector('#' + element.dataset.target).classList.add('active');
        })
    })
})

// Count the wines in cart then show .wines-in-cart
if ( wine_minimum_enable == true || checkout_via_condition == true ) {
    document.addEventListener('cart:refresh', () => {
        let listAllWines = [];
        let countAllWines = [];

        fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
            if ( wine_minimum_enable == true ) {
                console.log('Custom: Wines in cart')
                cart.items.forEach(item => {
                    if ( item.product_type != "Gift Giving" ) {
                        listAllWines.push(item.product_id);
                    }
                })

                if ( listAllWines.length >= wine_minimum) {
                    document.querySelectorAll('.wines-in-cart').forEach( item => {
                        item.classList.add('active');
                    })
                }
            }

            if ( checkout_via_condition == true ) {
                console.log('Custom: Checkout via Condition');

                if ( document.querySelector('#checkout_base_condition') ) {
                    document.querySelector('#checkout_base_condition').style.display = 'none';
                }

                cart.items.forEach(item => {
                    if ( item.product_type != "Gift Giving" ) {
                        countAllWines.push(
                            {
                                'id': item.product_id,
                                'quantity': item.quantity
                            }
                        );
                    }
                })

                let checker = cart.items.find(i => i.id === checkout_product_condition ); 
                
                if ( checker ) {
                    console.log('Custom: Checkout Product Condition Found!')
                    document.querySelector('#CartDrawer-Checkout').disabled = true;
                    document.querySelector('#CartDrawer-Checkout').classList.add('disabled');
                    document.querySelector('.drawer__footer-actions').classList.add('disabled');

                    document.querySelectorAll('.wines-in-cart').forEach( item => {
                        item.classList.remove('active');
                    })

                    let totalQty = countAllWines.reduce((sum, obj) => sum + obj.quantity, 0);

                    if ( document.querySelector('#checkout_base_condition') ) {
                        document.querySelector('#checkout_counter').innerHTML = totalQty
                        document.querySelector('#checkout_base_condition').style.display = 'block';
                    }

                    if ( totalQty >= checkout_limit ) {
                        
                        console.log('Custom: Checkout limit Reach! Enable checkout')
                        document.querySelector('#CartDrawer-Checkout').disabled = false;
                        document.querySelector('#CartDrawer-Checkout').classList.remove('disabled');
                        document.querySelector('.drawer__footer-actions').classList.remove('disabled');

                        
                        if ( document.querySelector('#checkout_base_condition') ) {
                            document.querySelector('#checkout_base_condition').style.display = 'none';
                        }
                    }
                }
            }
        })
    })
}

// GWP
if ( gwp == true && Shopify.currency.active == "AUD" && gwp_product_available == true ) {
    document.addEventListener('cart:refresh', () => {
        console.log('Custom: GWP');
        fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
            
            let checker = cart.items.find(i => i.id === gwp_product_variant_id);

            if ( cart.total_price > gwp_threshold ) {
                console.log('Custom: Cart total > GWP Threshold');
                if ( !checker ) {
                    console.log('Custom: Adding GWP');

                    variants = {
                        'items': [
                            {
                                'id': gwp_product_variant_id,
                                'quantity': 1
                            }
                        ]
                    }

                    addToCart(variants, true);
                    // addToCartSection();

                } else {
                    console.log('Custom: GWP Already in cart');
                }
            } else {
                console.log('Custom: Cart total < GWP Threshold');

                if ( checker ) {
                    console.log('Custom: GWP Product found! Removing');
                    
                    let updates = {
                        id: gwp_product_variant_id.toString(),
                        quantity: 0
                    }

                    updateCart(updates);
                } else {
                    console.log('Custom: GWP is not in cart');
                }
            }
        })
    })
}